import { ReactNode } from 'react';
import { AlertTriangle, CheckCircle, Info, XCircle } from 'lucide-react';

type AlertVariant = 'error' | 'warning' | 'success' | 'info';

interface AlertProps {
    variant?: AlertVariant;
    children: ReactNode;
    className?: string;
}

const config: Record<AlertVariant, { icon: typeof Info; classes: string }> = {
    error: { icon: XCircle, classes: 'bg-red-50 border-red-200 text-red-700' },
    warning: { icon: AlertTriangle, classes: 'bg-amber-50 border-amber-200 text-amber-700' },
    success: { icon: CheckCircle, classes: 'bg-emerald-50 border-emerald-200 text-emerald-700' },
    info: { icon: Info, classes: 'bg-sky-50 border-sky-200 text-sky-700' },
};

export const Alert = ({ variant = 'error', children, className = '' }: AlertProps) => {
    const { icon: Icon, classes } = config[variant];
    return (
        <div className={`flex items-start gap-3 p-4 rounded-xl border text-sm ${classes} ${className}`}>
            <Icon className="w-4 h-4 flex-shrink-0 mt-0.5" />
            <div>{children}</div>
        </div>
    );
};
